import React from "react";
import BrushableTimeline from "./BrushableTimeline";
import * as d3 from "d3";
import CompactIconButton from "../CompactIconButton";
import withStyles from "@mui/styles/withStyles";

import { ZoomIn as IconZoomIn, ZoomOut as IconZoomOut } from "@mui/icons-material";

const styles = {
  root: {
    position: "absolute",
    height: 100,
    bottom: 15,
    left: 15,
    right: 15,
    zIndex: "3",
    backgroundColor: "rgba(66, 66, 66, 0.55)",
    border: "1px solid lightgray",
    borderRadius: 10,
  },
  toolBar: {
    color: "lightgray",
    position: "absolute",
    top: 8,
    bottom: 8,
    display: "block",
  },
  dateReadout: {
    position: "absolute",
    top: -25,
    right: 8,
    color: "lightgray",
    fontSize: "10pt",
    borderRadius: 4,
    padding: 2,
    backgroundColor: "rgba(66, 66, 66, 0.55)",
    fontFamily: "sans-serif",
  },
};

const formatDate = d3.utcFormat("%Y-%m-%d %H:%M");

class TimelinePanel extends React.PureComponent {
  constructor(props) {
    super(props);
  }
  render() {
    const {
      detCount,
      zoomTimeRange,
      brushTimeRange,
      brushTimeRangeHandler,
      binSize,
      timeOffset,
      zoomInHandler,
      resetZoomHandler,
      classes,
    } = this.props;

    const readoutTimeRange = (brushTimeRange || zoomTimeRange)
      .map(t => t.getTime() + timeOffset)
      .map(formatDate)
      .join(" → ");

    return (
      <div className={classes.root}>
        <BrushableTimeline
          data={detCount}
          timeZoom={zoomTimeRange}
          timeRangeHandler={brushTimeRangeHandler}
          binSize={binSize}
          timeOffset={timeOffset}
        />

        <div className={classes.dateReadout}>{readoutTimeRange}</div>

        <div className={classes.toolBar} style={{ right: 6 }}>
          <CompactIconButton onClick={zoomInHandler}>
            <IconZoomIn />
          </CompactIconButton>
          <CompactIconButton onClick={resetZoomHandler}>
            <IconZoomOut />
          </CompactIconButton>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(TimelinePanel);
